
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoPurInvoiceAppEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoPurInvoiceAppRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoPurInvoiceAppRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
